import { Injectable } from "@angular/core";
import { HttpclientService, UserService, UserInfo } from "../../../../shared";
import { Subject } from "rxjs";

@Injectable()
export class Top5Service {
	constructor(private httpclientService: HttpclientService, private userService: UserService) {}

	Top5SelectInfo(UserID, SchoolID) {
		var postResult$ = new Subject();
		var url = "api/token/Top5SelectInfo?UserID=" + UserID + "&SchoolID=" + SchoolID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}
}
